import React from "react";

import EventCalendar from "./EventCalendar";

const Calendar = () => {
   return (
      <>    
         <EventCalendar />
      </>
   );
};

export default Calendar;
